import api from 'api';
import ListUtilities from 'records/ListUtilities';
import { periodFields } from 'constants/salesPeriods';

export const CREATE_SALES_PERIOD_ACTION_START = 'CREATE_SALES_PERIOD_ACTION_START';
export const CREATE_SALES_PERIOD_ACTION_ERROR = 'CREATE_SALES_PERIOD_ACTION_ERROR';
export const CREATE_SALES_PERIOD_ACTION_SUCCESS = 'CREATE_SALES_PERIOD_ACTION_SUCCESS';
export const SET_LOADING_SALES_PERIODS_STATUS = 'SET_LOADING_SALES_PERIODS_STATUS';
export const SET_SALES_PERIOD_DATA = 'SET_SALES_PERIOD_DATA';
export const RESET_SALES_PERIOD_DATA = 'RESET_SALES_PERIOD_DATA';
export const UPDATE_SELECTED_PERIOD = 'UPDATE_SELECTED_PERIOD';
export const UPDATE_SELECTED_SORT_OPTION = 'UPDATE_SELECTED_SORT_OPTION';
export const DELETE_SALES_PERIOD = 'DELETE_SALES_PERIOD';
export const UPDATE_SALES_PERIOD = 'UPDATE_SALES_PERIOD';

/**
 * Start create new sales period action
 */
export const createSalesPeriodActionStart = () => {
    return {
        type: CREATE_SALES_PERIOD_ACTION_START,
    };
};

/**
 * Create new sales period error action
 * @param error
 */
export const createSalesPeriodActionError = (error) => {
    return {
        type: CREATE_SALES_PERIOD_ACTION_ERROR,
        payload: error,
    };
};

/**
 * Create new sales period success action
 * @param data
 */
export const createSalesPeriodActionSuccess = (data) => {
    return {
        type: CREATE_SALES_PERIOD_ACTION_SUCCESS,
        payload: data,
    };
};

/**
 * Set the loading status
 * @param {Boolean} isLoading is loading: true/false
 */
const setLoadingStatus = isLoading => ({
    type: SET_LOADING_SALES_PERIODS_STATUS,
    isLoading,
});

/**
 * Set sales period list in store
 * @param {List} data list of sales-period objects
 */
const getSalesPeriodDataSuccess = data => ({
    type: SET_SALES_PERIOD_DATA,
    payload: {
        data,
        latestId: ListUtilities.getMaximumPropValue(data, periodFields.START_DATE, periodFields.PERIOD_ID),
    }
});

/**
 * Set sales periods in store on error
 * @param {Error} error error
 */
const getSalesPeriodDataFailure = error => ({
    type: SET_SALES_PERIOD_DATA,
    payload: {
        data: [],
    }
});

/**
 * Clear store data which belongs to sales-period
 */
export const resetSalesPeriodState = () => ({
    type: RESET_SALES_PERIOD_DATA,
});

/**
 * Create sales period in backend
 * @param {*} salesPeriod
 */
export function createSalesPeriod(salesPeriod) {
    return (dispatch, getState) => {
        
        dispatch(createSalesPeriodActionStart());

        return api.request('sales-periods', 'post', salesPeriod)
            .then((data) => {
                dispatch(createSalesPeriodActionSuccess(data));
            })
            .catch((err) => {
                console.log("Error: createSalesPeriod():", err);
                dispatch(createSalesPeriodActionError('Create new sales period failed'));
                throw (err);
            });
    };
}

/**
 * Fetch sales periods
 * @param {Number/String} menuId menuId
 */
export const getSalesPeriodsAsync = menuId =>
    (dispatch, getState) => {
        
        dispatch(setLoadingStatus(true))
        return api.request(`sales-periods?menuId=${menuId}`, 'get')
            .then(data => dispatch(getSalesPeriodDataSuccess(data)))
            .catch(err => dispatch(getSalesPeriodDataFailure(err)))
            .finally(() => dispatch(setLoadingStatus(false)));
    };

/**
 * update selected period Id on store
 * @param {Number} periodId selected period Id
 */
export const updateSelectedPeriod = periodId => ({
    type: UPDATE_SELECTED_PERIOD,
    selectedPeriodId: periodId,
});

/**
 * update selected sort id option
 * @param {Number} sortId selected sort Id
 */
export const updateSelectedSortOption = sortId => ({
    type: UPDATE_SELECTED_SORT_OPTION,
    selectedSortId: sortId,
});

/**
 * Delete the period element from the store
 * @param {Number/String} periodId period Id to be deleted
 */
export const deleteSalesPeriodDataSuccess = periodId => ({
    type: DELETE_SALES_PERIOD,
    deletedId: parseInt(periodId),
})

/**
 * Initiate request to Delete given period Id 
 * Note: error not handled (can trigger upon errors)
 * @param {Number} periodId periodId to be deleted
 */
export const deleteSalesPeriodAsync = periodId =>
    (dispatch, getState) => {
        
        dispatch(setLoadingStatus(true))
        return api.request(`sales-periods/${periodId}`, 'delete')
            .then(({ periodId: id }) => dispatch(deleteSalesPeriodDataSuccess(id)))
            .finally(() => dispatch(setLoadingStatus(false)));
    };

/**
 * Update the period element in the store
 * @param {Object} data updated salesPeriod object 
 */
export const updateSalesPeriodDataSuccess = data => ({
    type: UPDATE_SALES_PERIOD,
    data,
})

/**
 * Initiate requiest to update the sales-period
 * @param {Object} patchBody patch request body
 */
export const updateSalesPeriodAsync = patchBody =>
    (dispatch, getState) => {
        
        dispatch(setLoadingStatus(true))
        return api.request(`sales-periods`, 'patch', patchBody)
            .then(data => dispatch(updateSalesPeriodDataSuccess(data)))
            .finally(() => dispatch(setLoadingStatus(false)));
    };
